import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';



@withRouter
@inject("store")

export default class Twice extends Component
{
   

    zerotoone() {
        this.props.store.zerooo= "nothing";
        this.forceUpdate();
        this.props.history.push("/zerotoone");
    }

    bigstory(){
        this.props.store.bigstory = "nothing";
        this.forceUpdate();
        this.props.history.push("/bigstory");
    }

    storymodel() {
        this.props.store.storymodel = "nothing";
        this.forceUpdate();
        this.props.history.push("/storymodel");
    }

    writing(){
        this.props.store.upsetwith = "writingyes";
        this.props.store.writingyes = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    writing2(){
        this.props.store.upsetwith = "writingyes";
        this.props.store.writingyes = "writingyes2";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    writing3(){
        this.props.store.upsetwith = "writingyes";
        this.props.store.writingyes = "writingyes3";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    plot(){
        this.props.store.upsetwith = "plotyes";
        this.props.store.plotyes = "nothing";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    plot2(){
        this.props.store.upsetwith = "plotyes";
        this.props.store.plotyes = "plotyes2";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    plot3(){
        this.props.store.upsetwith = "plotyes";
        this.props.store.plotyes = "plotyes3";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    formation1(){
        this.props.store.upsetwith = "formationyes";
        this.props.store.formationyes ="formationyes2";
        this.forceUpdate();
        this.props.history.push("/improve");
    }

    formation2(){
        this.props.store.upsetwith = "formationyes";
        this.props.store.formationyes ="formationyes3";
        this.forceUpdate();
        this.props.history.push("/improve");
    }
  
    render()
    {
        return <div className = "twice">
              <img src={cookie} className="cookiepicture" alt="cookie" />
              <br/>
              <div className = "twicetext">请选择你想看的讲解<br/><br/>
              故事指南：<br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.zerotoone() } >从无到有小故事指南</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.bigstory() } >大故事指南</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.storymodel() } >故事模版</Button><br/>
              <br/>
              文笔指南：<br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.writing() }>文笔练习</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.writing2()}>摘抄</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.writing3() }>仿写</Button><br/>
              <br/>
              情节指南：<br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.plot() }>情节讲解</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.plot2()}>摘抄仿写</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.plot3() }>自己收集</Button><br/>
              <br/>
              结构指南：<br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.formation1() }>故事线</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.formation2()}>大纲</Button><br/>
              </div>
           
   
            
             



        </div>;
    }
} 